import { ISearchFilters, ISearchType } from "./SearchPage";
import { Dispatch, SetStateAction } from "react";
import {
  IReactiveEventContentItem,
  IReactiveNewsContentItem,
  ReactiveContentItem,
} from "../../components/schoolfeed/SchoolFeedContentItem";
import { ResultsHOC } from "./ResultsHOC";
import NewsSelector from "../../components/blocks/TerracedGridTheme/NewsBlock/NewsSelector";
import { PaginationFooter } from "./PaginationFooter";
import { MutatorCallback } from "swr";

export function ContentItemResults(props: {
  searchTypes: ISearchType[];
  results: {
    news_items?: {
      data: Array<IReactiveNewsContentItem>;
      meta: { total: number };
    };
    event_items?: {
      data: Array<IReactiveEventContentItem>;
      meta: { total: number };
    };
  };
  contentType: "news_items" | "event_items";
  filters: ISearchFilters;
  setFilters: Dispatch<SetStateAction<ISearchFilters>>;
  isValidating: boolean;
  cacheKey: string;
  searchTerm: string;
  mutate: MutatorCallback & ((data: any, shouldRevalidate: boolean) => void);
}) {
  const page = props.filters[`${props.contentType}.page`];
  const pageSize = props.filters[`${props.contentType}.page_size`];
  let contentResults: {
    data:
      | Array<IReactiveNewsContentItem | IReactiveEventContentItem>
      | undefined;
    meta: { total: number };
  } = { data: undefined, meta: { total: 0 } };
  let total = 0;
  let totalPages = 0;
  if (props.results) {
    contentResults = props.results[props.contentType] as {
      data: Array<IReactiveEventContentItem | IReactiveNewsContentItem>;
      meta: { total: number };
    };
    total = contentResults?.meta.total || 0;
    totalPages = Math.ceil(total / pageSize);
  }

  return (
    <ResultsHOC
      isLoading={contentResults?.data === undefined}
      isValidating={props.isValidating}
      resultsCount={total}
      searchTypes={props.searchTypes}
      thisComponentType={props.contentType}
      searchTerm={props.searchTerm}
      noResultsString={props.contentType === "news_items" ? "News" : "Events"}
    >
      {contentResults?.data && (
        <NewsSelector
          contentItems={contentResults.data}
          aboveTheFold={true}
          key={props.results?.["prevKey"]}
          getItemAtIndex={async (idx) => {
            return contentResults.data
              ? (contentResults.data[idx] as ReactiveContentItem)
              : null;
          }}
          hideLeftColumn={true}
          totalItemCount={contentResults.data?.length}
          handleDelete={(contentItem) => {
            props.mutate((currentData: typeof props.results) => {
              const contentData = currentData[props.contentType]?.data ?? [];

              return {
                ...currentData,
                [props.contentType]: {
                  ...currentData[props.contentType],
                  data: (
                    contentData as Array<
                      IReactiveNewsContentItem | IReactiveEventContentItem
                    >
                  ).filter((c) => c.id !== contentItem.id),
                },
              };
            }, false);
          }}
        />
      )}
      <PaginationFooter
        currentPage={page}
        setPage={(page) =>
          props.setFilters((v) => ({
            ...v,
            [`${props.contentType}.page`]: page,
          }))
        }
        totalPages={totalPages}
      />
    </ResultsHOC>
  );
}
